import script from "./AUDIT_COMMENT_ITEM_TYPE_CHANGED.vue?vue&type=script&setup=true&lang=ts"
export * from "./AUDIT_COMMENT_ITEM_TYPE_CHANGED.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__